import styled from 'styled-components';


export const FormInput = styled.input<{grow? : boolean}>`

    ${p => p.grow ? 'width: 100%;' : ''}
    
`;

